var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Info"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.4358 21C17.1592 21 21.7989 16.5228 21.7989 11C21.7989 5.47715 17.1592 1 11.4358 1C5.71236 1 1.07263 5.47715 1.07263 11C1.07263 16.5228 5.71236 21 11.4358 21Z",
    fill: "#F0F1F2",
    stroke: "#171926",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.4358 16V11",
    stroke: "#171926",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.436 6.33008C11.3207 6.33008 11.208 6.36308 11.1121 6.42489C11.0162 6.48671 10.9415 6.57458 10.8974 6.67738C10.8532 6.78018 10.8417 6.8933 10.8642 7.00243C10.8867 7.11156 10.9422 7.21181 11.0238 7.29049C11.1053 7.36917 11.2092 7.42275 11.3223 7.44445C11.4354 7.46616 11.5526 7.45502 11.6591 7.41244C11.7657 7.36986 11.8567 7.29775 11.9208 7.20523C11.9848 7.11271 12.019 7.00394 12.019 6.89267C12.0192 6.81874 12.0043 6.74549 11.9751 6.67714C11.9459 6.6088 11.9029 6.5467 11.8487 6.49442C11.7946 6.44214 11.7302 6.4007 11.6594 6.3725C11.5885 6.3443 11.5126 6.32988 11.436 6.33008Z",
    fill: "#171926",
    stroke: "#171926",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
export default SvgInfo;